import { api, AUTH_URL } from './client';

// ---- Identity operations ----

export async function listIdentities(options = {}) {
  return api.get(`${AUTH_URL}/api/v1/me/identities`, options);
}

export async function getIdentity(identityId, options = {}) {
  return api.get(`${AUTH_URL}/api/v1/me/identities/${identityId}`, options);
}

export async function initiateLinking(provider, returnUrl = null, options = {}) {
  const body = { provider };
  if (returnUrl) {
    body.return_url = returnUrl;
  }
  return api.post(`${AUTH_URL}/api/v1/me/identities`, body, options);
}

export async function setPrimaryIdentity(identityId, options = {}) {
  return api.put(`${AUTH_URL}/api/v1/me/identities/${identityId}`, { is_primary: true }, options);
}

export async function unlinkIdentity(identityId, options = {}) {
  return api.delete(`${AUTH_URL}/api/v1/me/identities/${identityId}`, options);
}

// ---- Metadata operations ----

export async function getMetadata(options = {}) {
  return api.get(`${AUTH_URL}/api/v1/me/metadata`, options);
}

export async function setActiveMetadata(fieldName, historyId, options = {}) {
  return api.put(`${AUTH_URL}/api/v1/me/metadata`, { field: fieldName, history_id: historyId }, options);
}

// ---- Merge operations ----

export async function listMergeRequests(options = {}) {
  return api.get(`${AUTH_URL}/api/v1/merge-requests`, options);
}

export async function getMergeRequest(mergeId, options = {}) {
  return api.get(`${AUTH_URL}/api/v1/merge-requests/${mergeId}`, options);
}

export async function approveMerge(mergeId, targetUserId, fieldChoices = {}, options = {}) {
  return api.post(`${AUTH_URL}/api/v1/merge-requests/${mergeId}/approve`, {
    target_user_id: targetUserId,
    strategy: { field_choices: fieldChoices, target_user_id: targetUserId },
  }, options);
}

export async function rejectMerge(mergeId, reason = null, options = {}) {
  const body = reason ? { reason } : {};
  return api.post(`${AUTH_URL}/api/v1/merge-requests/${mergeId}/reject`, body, options);
}

// ---- Helper functions ----

// Redirect to link a new identity
export function redirectToLinkIdentity(authUrl) {
  window.location.href = authUrl;
}
